<template>
  <div id="PowiazanieModulowDodanie">
    <div id="content">

      <table class="table-created">
        <tr>
          <td>obudowa</td>
          <td>
            <select v-model="fieldsData.id_obudowa" name="producent" id="producent" placeholder="obudowa"
            class="form-select form-select-sm" aria-label=".form-select-sm example">
              <!-- <option value="null">wybierz obudowę</option> -->
              <option v-for="obudowa in obudowy" :key="obudowa.id_obudowa" :value="obudowa.id_obudowa">{{obudowa.symbol}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>modul</td>
          <td>
            <select v-model="fieldsData.id_modul" name="producent" id="producent" placeholder="modul"
            class="form-select form-select-sm" aria-label=".form-select-sm example">
              <!-- <option value="null">wybierz centralę</option> -->
              <option v-for="modul in moduly" :key="modul.idmodul" :value="modul.idmodul">{{modul.producent}} : {{modul.model}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>wspX</td>
          <td><input v-model="fieldsData.wspX" type="text" class="form-control form-control-sm "></td>
        </tr>
        <tr>
          <td>wspY</td>
          <td><input v-model="fieldsData.wspY" type="text" class="form-control form-control-sm "></td>
        </tr>
        <tr>
          <td>ułożenie</td>
          <td>
            <div class="md-layout-item">
              <input type="checkbox" value=1 v-model="fieldsData.o0"> 0&#176; &nbsp; &nbsp;
              <input type="checkbox" value=1 v-model="fieldsData.o90"> 90&#176; &nbsp; &nbsp;
              <input type="checkbox" value=1 v-model="fieldsData.o180"> 180&#176; &nbsp; &nbsp;
              <input type="checkbox" value=1 v-model="fieldsData.o270"> 270&#176; &nbsp; &nbsp;
                <!-- <select v-model="fieldsData.o0" name="o1" id="o1" placeholder=""
                class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=''>-</option>
                  <option value=1>TAK</option>
                </select> -->
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td>90&#176;</td>
          <td>
            <div class="md-layout-item">
                <select v-model="fieldsData.o90" name="o2" id="o2" placeholder=""
                class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=''>-</option>
                  <option value=1>TAK</option>
                </select>
            </div>
          </td>
        </tr>
        <tr>
          <td>180&#176;</td>
          <td>
            <div class="md-layout-item">
                <select v-model="fieldsData.o180" name="o3" id="o3" placeholder=""
                class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=''>-</option>
                  <option value=1>TAK</option>
                </select>
            </div>
          </td>
        </tr>
        <tr>
          <td>270&#176;</td>
          <td>
            <div class="md-layout-item">
                <select v-model="fieldsData.o270" name="o4" id="o4" placeholder=""
                class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=''>-</option>
                  <option value=1>TAK</option>
                </select>
            </div>
          </td>
        </tr> -->
        <tr>
          <td>ścianka</td>
          <td>
            <div class="md-layout-item">
                <select v-model="fieldsData.scianka" name="scianka" id="scianka" placeholder=""
                class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option v-for="v in groupViews" :key="v">{{v}}</option>
                </select>
            </div>
          </td>
        </tr>
        <tr>
          <td>aktywna</td>
          <td>
            <select v-model="fieldsData.widocznosc" name="widocznosc" id="widocznosc"
                class="form-select form-select-sm" aria-label=".form-select-sm example">
              <option value=1>TAK</option>
              <option value=0>NIE</option>
            </select>
          </td>
        </tr>
      </table>

      <div style="width: 100%;text-align: center;margin-top:20px"><button @click="zapiszPowiazanie()" class="btn btn-success" style="width:200px">Zapisz</button></div>

    <md-dialog-alert
      :md-active.sync="second"
      md-title="Uwaga!"
      md-content="<span style='color: red;font-size: 20px;'>Wszystkie pola muszą być wypełnione.</span>" />
    </div>

  </div>
</template>

<script>
import { app } from '../mixins/functions'
import { mapGetters } from 'vuex'

export default {
  name: 'PowiazanieModulowDodanie',
  mixins: [app],
  data () {
    return {
      fieldsData: {
        'obudowa': null,
        'id_obudowa': null,
        'modul': null,
        'id_modul': null,
        'wspX': 0,
        'wspY': 0,
        'o0': '',
        'o90': '',
        'o180': '',
        'o270': '',
        'scianka': 'C',
        'widocznosc': 1
      },
      second: false
    }
  },
  computed: {
    ...mapGetters('products', ['moduly', 'obudowy'])
  },
  methods: {
    getEnclosures () {
      console.log(this.selectedItem.producent)
      console.log(this.selectedItem.modul)
    },
    zapiszPowiazanie () {
      var obroty = 0
      const self = this

      if ((this.fieldsData.o0 !== null && this.fieldsData.o0 !== 'null') || (this.fieldsData.o90 !== null && this.fieldsData.o90 !== 'null')
       || (this.fieldsData.o180 !== null && this.fieldsData.o180 !== 'null') || (this.fieldsData.o270 !== null && this.fieldsData.o270 !== 'null')) {
        obroty++
      }

      if (this.fieldsData.id_obudowa === null || this.fieldsData.id_modul === null || this.fieldsData.wspX === null || this.fieldsData.wspY === null || obroty === 0) {
        // alert('Muszą być wszystkie pola wypełnione')
        this.second = true
      } else {

        if (this.fieldsData['wspX'] !== '' && this.fieldsData['wspX'] !== 0) {
          this.fieldsData['wspX'] = this.fieldsData['wspX'].replace(',', '.')
        }
        if (this.fieldsData['wspY'] !== '' && this.fieldsData['wspY'] !== 0) {
          this.fieldsData['wspY'] = this.fieldsData['wspY'].replace(',', '.')
        }
        this.$store.dispatch('products/send_connection_moduly', {'action': 'add', 'fields': this.fieldsData}).then(info => {
          self.$emit('someEvent', true)
          self.inputFields = {
            'obudowa': null,
            'id_obudowa': null,
            'centrala': null,
            'id_centrala': null,
            'wspX': 0,
            'wspY': 0,
            'o0': '',
            'o90': '',
            'o180': '',
            'o270': '',
            'scianka': 'C'
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.colinpPunkt {
  width: 280px;
}
.inpPunkt {
  width: 80px;
  text-align: center;
}
.table-created {
max-width: 368px;
width: 100%;
margin: 0px auto;
}
table.table-created tr {
height: 40px;
}
table.table-created tr td {
  text-align: left;
}
table.table-created tr td span{
margin-left: 5px;
}
table.table-created tr td span input {
width: 115px;
display: inline-flex;
}

table.table-created tr td:first-child {
  width: 110px;
}

#content {
  max-width: 1200px;
  margin: 0px auto;
}
#content h3 {
  background: beige;
  padding: 10px;
  font-size: 20px;
  text-transform: uppercase;
}
#content .table {
  margin-top:40px
}
#content .table tr.head {
  background: #3f7bc8;
}
#content .table tr th {
font-size: 14px;
font-weight: normal;
color: #fff;
padding: 4px;
border-left: 2px solid white;
}
.inputWsp {
  width: 80px;
  text-align: center;
  margin: 0px auto;
}
.md-ripple {
  min-height: 30px;
}
#tabPanel tr td input {
  width: 65px;
  padding: 4px;
  text-align: center;
}
.form-select, .form-control {
  padding: 4px 6px;
}
.inputSmall {
  width:65px;
}
.longSmall {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PowiazanieModulyDodanie.vue